module.exports = __webpack_public_path__ + "img/panorama.b2c09b92.png";